/**
 * Rutas de Producción
 * Gestión productiva: órdenes de fabricación, programación, OEE, materiales, lotes
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import OrdenesFabricacion from '../pages/produccion/orders/OrdenesFabricacion.jsx'
import Programacion from '../pages/produccion/scheduling/Programacion.jsx'
import OEEMetricas from '../pages/produccion/oee/OEEMetricas.jsx'
import MaterialesConsumos from '../pages/produccion/materials-consumption/MaterialesConsumos.jsx'
import LotesTrazabilidad from '../pages/produccion/traceability/LotesTrazabilidad.jsx'

export const productionRoutes = [
  <Route 
    key="ordenes-fabricacion" 
    path="/ordenes-fabricacion" 
    element={
      <ProtectedRoute>
        <OrdenesFabricacion />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="programacion" 
    path="/programacion" 
    element={
      <ProtectedRoute>
        <Programacion />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="oee-metricas" 
    path="/oee-metricas" 
    element={
      <ProtectedRoute>
        <OEEMetricas />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="materiales-consumos" 
    path="/materiales-consumos" 
    element={
      <ProtectedRoute>
        <MaterialesConsumos />
      </ProtectedRoute>
    } 
  />,
  <Route 
    key="lotes-trazabilidad" 
    path="/lotes-trazabilidad" 
    element={
      <ProtectedRoute>
        <LotesTrazabilidad />
      </ProtectedRoute>
    } 
  />,
]

